<template>
    <main class="main">
        <section class="catalog-sec">
            <div class="container">
                <div class="product_container product_container__big">
                    <div class="catalog-sec__control-row">
                        <h3 class="category-title">{{ trans('Favourites') }}</h3>
                    </div>
                    <div class="product-row">
                        <div class="product" v-for="item in cards">
                            <a :to="item.slug" target="_self" :title="item.name" class="product__wrapper">
                                <div class="product__image_wrapper">
                                    <div v-if="showPreorder(item)" class="preorder">
                                        <span>{{ trans("Pre-order") }}</span>
                                    </div>
                                    <picture class="product__image product__first-image">
                                        <source :srcset="item.img_first.wepb"
                                                type="image/webp">
                                        <img :src="item.img_first.jpeg"
                                             :alt="item.name"
                                             class="product__image product__first-image">
                                    </picture>
                                    <picture class="product__image product__second-image">
                                        <source :srcset="item.img_last.wepb"
                                                type="image/webp">
                                        <img :src="item.img_last.jpeg"
                                             :alt="item.name"
                                             class="product__image product__second-image">
                                    </picture>
                                    <span @click.prevent="updateLike(item)" :class="item.favourites ? 'active-like' : '' " class="add-like">
                                        <svg class="svg-icon" width="22" height="18" viewBox="0 0 22 18" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M11 17.25C11 17.25 1.625 12 1.625 5.62501C1.625 4.49803 2.01546 3.40585 2.72996 2.53431C3.44445 1.66277 4.43884 1.0657 5.54393 0.844677C6.64903 0.623658 7.79657 0.792346 8.79131 1.32204C9.78605 1.85174 10.5665 2.70972 11 3.75001V3.75001C11.4335 2.70972 12.2139 1.85174 13.2087 1.32204C14.2034 0.792346 15.351 0.623658 16.4561 0.844677C17.5612 1.0657 18.5555 1.66277 19.27 2.53431C19.9845 3.40585 20.375 4.49803 20.375 5.62501C20.375 12 11 17.25 11 17.25Z"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                            </path>
                                        </svg>
                                    </span>
                                    <div class="select-size product__size-selector" v-if="item.offer_show">
                                        <div class="select-size__header select-active">
                                            <p class="select-size__header-title">{{trans('Choose a size')}}</p>
                                        </div>
                                        <div class="select-size__body select-size__body_displayed">
                                            <ul class="list select-size__list">
                                                <template v-for="offer in item.offers">
                                                    <li class="list__element select-size__element" v-if="offer.purchase" @click.prevent="setSize(item,offer)">
                                                        <span class="select-size__element-value">{{ offer.size.code }}</span>
                                                        <span class="select-size__element-value"></span>
                                                    </li>
                                                </template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <button v-if="item.offerForPurchaseQuantity" class="btn btnV2" @click.prevent="addBasketCard(item)">{{ trans('add to basket') }}</button>
                                <div class="product__info">
                                    <h3 class="product__title">
                                        <span class="product__title-link">{{ item.name }}</span>
                                    </h3>
                                    <div class="product__price-row">
                                        <template v-if="item.offer.price_old_str">
                                            <p class="product__sale-price product__text-def"> {{ item.offer.price_str }}
                                                {{ item.signs }}</p>
                                            <p class="product__old-price"> {{ item.offer.price_old_str }} {{ item.signs }}</p>
                                        </template>
                                        <p class="product__main-price product__text-def" v-if="!item.offer.price_old_str">
                                            {{ item.offer.price_str }}
                                            {{ item.signs }}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
    <viewed/>
</template>

<script>
import Viewed from '../../components/viewed.vue'

export default {
    name: "favourites",
    components: {
        Viewed
    },
    data(){
        return{
            cards:[],
        }
    },
    mounted() {
        this.getCards()
    },
    methods:{
        showPreorder(card) {
            return (card.preorder_ru && this.$store.state.settings.site_id === 1) || (card.preorder_world && this.$store.state.settings.site_id === 2)
        },
        setSize(card,offer){
            card.offer = offer
            card.offer_show = false
            this.$parent.$refs.header.createBasket(card)
        },
        checkLike(cards) {
            let favourites = this.$store.state.settings.basket.favourites
            cards.forEach(function(card) {
                if (favourites.find(it => it.card_id === card.id)) {
                    card.favourites = true
                }
            })
            return cards
        },
        updateLike(card){
            card.favourites = !card.favourites
            this.$parent.$refs.header.updateLike(card)
            this.getCards()
        },
        addBasketCard(card) {
            if(card.offers.length > 1){
                card.offer_show  = true
            }else{
                this.$parent.$refs.header.createBasket(card)
            }
        },
        async getCards() {
            await axios.post('/api/v1/get-cards-ids', this.setParam({
                viewed:this.$store.state.settings.basket.favourites
            }))
                .then(data => {
                    this.cards =  this.checkLike(data.data['cards'])
                })
        },
    }
}
</script>

<style scoped>
.product__image_wrapper {
    position: relative;
}
</style>
